import { defaultNS, fallbackLng, resources } from "@klyra/i18n";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

await i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng,
		defaultNS,
		ns: [
			"common",
			"auth",
			"patients",
			"appointments",
			"assistant",
			"settings",
			"clinical",
			"dashboard",
			"photos",
			"medications",
			"lab",
			"dental",
			"packages",
			"derma",
			"obgyn",
			"peds",
			"radiology",
			"finance",
			"branches",
			"reviews",
			"tasks",
		],
		interpolation: { escapeValue: false },
		detection: {
			order: ["localStorage", "navigator"],
			caches: ["localStorage"],
			lookupLocalStorage: "klyra.lang",
		},
	});

// Sync html lang & dir whenever language changes. Kurdish Sorani (ckb) is
// RTL (Arabic script) like Arabic; English is the only LTR option.
function syncHtmlAttrs(lang: string) {
	const isRtl = lang.startsWith("ar") || lang.startsWith("ckb");
	document.documentElement.lang = lang.startsWith("ar")
		? "ar"
		: lang.startsWith("ckb")
			? "ckb"
			: "en";
	document.documentElement.dir = isRtl ? "rtl" : "ltr";
}

syncHtmlAttrs(i18n.language);
i18n.on("languageChanged", syncHtmlAttrs);

export default i18n;
